import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=7e060f05&scoped=true&"
import script from "./CreateUser.vue?vue&type=script&lang=ts&"
export * from "./CreateUser.vue?vue&type=script&lang=ts&"
import style0 from "./CreateUser.vue?vue&type=style&index=0&id=7e060f05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e060f05",
  null
  
)

export default component.exports